<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<ng-container *ngIf="!hasToPlaceIconRelative">
  <ng-container *ngTemplateOutlet="audioIconButton"></ng-container>
</ng-container>

<idt-common-styles-render
  *ngIf="piece"
  [styles]="piece.settings?.styles">
  <ng-container
    *ngIf="settings.general.link?.type; else ownVideo">
    <render-link
      *ngIf="settings?.general?.link?.type && typeOfVideo === 'own'"
      [analyticsEventName]="analyticsEventClickVideo"
      [analyticsEventData]="analyticsEventData"
      [lang]="lang"
      [link]="settings.general.link"
      [piece]="piece"
      (renderLinkEvent)="onRenderLinkClick($event)">
      <ng-container *ngTemplateOutlet="ownVideo"></ng-container>
    </render-link>
  </ng-container>

  <ng-container
    *ngIf="settings.general.link?.type; else externalVideo">
    <render-link
      *ngIf="settings?.general?.link?.type && (typeOfVideo === 'youtube' || typeOfVideo === 'vimeo')"
      [analyticsEventName]="analyticsEventClickVideo"
      [analyticsEventData]="analyticsEventData"
      [lang]="lang"
      [link]="settings.general.link"
      [piece]="piece"
      (renderLinkEvent)="onRenderLinkClick($event)">
      <ng-container *ngTemplateOutlet="externalVideo"></ng-container>
    </render-link>
  </ng-container>
</idt-common-styles-render>

<ng-template #ownVideo>
  <ng-container *idtLazyTemplate="emptyTemplate">
    <div *ngIf="typeOfVideo === 'own'">
      <ng-container *ngTemplateOutlet="coverText"></ng-container>
    </div>
    <ng-container *ngIf="this.settings?.general && orientation$ | async as orientation">
      <render-video
        *ngIf="typeOfVideo === 'own'"
        [title]="settings.general.title"
        [controls]="!!settings.general.showControls"
        [ariaLabel]="settings.general.alt"
        [loop]="settings.general.loop"
        [poster]="getPosterImageSrc(orientation)"
        [muted]="isMuted"
        [autoPlay]="!!settings.general.autoPlay"
        [clickable]="!!settings.general.clickToPlayPause"
        [source]="videoSrc$ | async">
      </render-video>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #emptyTemplate>
  <div
    *ngIf="(skeleton$ | async) as skeleton"
    [ngStyle]="{
      'width': skeleton.width,
      'height': skeleton.height
    }">&nbsp;</div>
</ng-template>

<ng-template #externalVideo>
  <div *ngIf="typeOfVideo === 'youtube' || typeOfVideo === 'vimeo'">
    <ng-container *ngTemplateOutlet="coverText"></ng-container>
    <ng-container *ngIf="orientation$ | async as orientation">
      <div *ngIf="isLoadingVideo && getPosterImageSrc(orientation) as image">
        <img
          class="iframe-video-poster"
          [src]="image?.src"
          alt="Poster de {{ this.settings.general.typeOfVideo }}">
      </div>
    </ng-container>
    <div
      *ngIf="typeOfVideo === 'youtube' || typeOfVideo === 'vimeo'"
      class="iframe-video"
      data-e2e="iframe-video"
      [class.pointer-events]="settings.general.link?.type"
      [innerHtml]="videoSrc$ | async">
    </div>
  </div>
</ng-template>

<ng-template #audioIconButton>
  <div
    *ngIf="settings.general.showMediaAudio"
    [ngClass]="{
      'audio-icon-top-left': audioIconPosition === 'top-left',
      'audio-icon-top-center': audioIconPosition === 'top-center',
      'audio-icon-top-right': audioIconPosition === 'top-right',
      'audio-icon-center-left': audioIconPosition === 'center-left',
      'audio-icon-center-center': audioIconPosition === 'center-center',
      'audio-icon-center-right': audioIconPosition === 'center-right',
      'audio-icon-bottom-left': audioIconPosition === 'bottom-left',
      'audio-icon-bottom-center': audioIconPosition === 'bottom-center',
      'audio-icon-bottom-right': audioIconPosition === 'bottom-right',
      'audio-icon-top-text': audioIconPosition === 'top-text',
      'audio-icon-bottom-text': audioIconPosition === 'bottom-text'
    }">
    <button
      *ngIf="settings.general.showMediaAudio"
      [ngClass]="isMuted ? 'muted' : 'not_muted'"
      class="audiomute-icon"
      aria-label="Audio mute"
      type="button"
      (click)="toggleAudioMute()">
      <svg
        *ngIf="isMuted"
        viewBox="0 0 24 24">
        <path
          d="M0 0h24v24H0z"
          fill="none"/>
        <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
      </svg>
      <svg
        *ngIf="!isMuted"
        viewBox="0 0 24 24">
        <path
          d="M0 0h24v24H0z"
          fill="none"/>
        <path d="M7 9v6h4l5 5V4l-5 5H7z"/>
      </svg>
    </button>
  </div>
</ng-template>

<ng-template #coverText>
  <div
    class="wysiwyg"
    *ngIf="!!settings && !!settings.general.coverText">
    <div
      class="wysiwyg-position"
      [ngClass]="{
        'container-icon-top-text': audioIconPosition === 'top-text',
        'container-icon-bottom-text': audioIconPosition === 'bottom-text'
      }">
      <ng-container *ngIf="hasToPlaceIconRelative">
        <ng-container *ngTemplateOutlet="audioIconButton"></ng-container>
      </ng-container>
      <render-wysiwyg
        *ngIf="settings && settings.general.coverText"
        [html]="settings.general.coverText"
        [country]="country"
        [lang]="lang"
        [piece]="piece"
        [textPaddingTop]="settings.general.textPaddingTop"
        [textPaddingBottom]="settings.general.textPaddingBottom"
        [textPaddingLeft]="settings.general.textPaddingLeft"
        [textPaddingRight]="settings.general.textPaddingRight"
        data-e2e="render-cover-text">
      </render-wysiwyg>
    </div>
  </div>
</ng-template>
